import { Avatar, Image, Box } from '@sequencehq/core-components'
import { useState } from 'react'

import { Customer } from 'modules/Customers/types'
import { getLogoSrc } from 'Customer/utils/logo'

export const CustomerLogo = ({
  customer,
  size = '48px'
}: {
  customer: Pick<Customer, 'legalName' | 'domain'>
  size?: string
}) => {
  const [isLogoError, setIsLogoError] = useState(false)

  const logoSrc = getLogoSrc(customer)

  if (isLogoError || !logoSrc) {
    return <Avatar name={customer.legalName} mr={2} />
  }

  return (
    <Box
      display="flex"
      width={size}
      height={size}
      alignItems="center"
      justifyContent="center"
    >
      <Image src={logoSrc} width="100%" onError={() => setIsLogoError(true)} />
    </Box>
  )
}
